
<template>
  <!-- 服务管理 serviceManagement -->
  <div>
    <!--删除列表时使用的是rowKey的id-->
    <x-tabula
      ref="table"
      rowKey="id"
      :dataSource="dataSource"
      :searchList="searchList"
      :columns="columns"
      :tableOptList="tableOptList"
      :rowOptList="rowOptList"
      :searchParams.sync="searchParams"
      :listApi="listApi"
      :addHandleParam="addHandleParam"
      :deleteParam="deleteParam"
      :rowSelection="false"
    >
      <template slot="opt_status" slot-scope="{row}">
        <div style="display: flex; align-items: center">
          <span class="circle-dot" :class="activityColor[row.serviceStatus]"></span>
          <span>{{ row.serviceStatusDesc }}</span>
        </div>
      </template>
      <template slot="opt_serviceStatus" slot-scope="{row}">
        <div style="display: flex; align-items: center">
          <span class="circle-dot" :class="activityColor[row.activeStatus]"></span>
          <span>{{ row.activeStatusDesc }}</span>
        </div>
      </template>
    </x-tabula>
  </div>
</template>

<script>
export default {
  name: 'localServiceManagement',
  data () {
    return {
      activityColor: [
        'info-bg',
        'success-bg',
        'info-bg'
      ],
      searchList: [
        { props: ['mobilePhone'], placeholder: '账号', options: [], inputType: 'input' },
        { props: ['name'], placeholder: '名称', options: [], inputType: 'input' },
        {
          props: ['activeStatus'],
          placeholder: '服务状态',
          options: [
            {label: '开通', value: 1},
            {label: '关闭', value: 0}
          ],
          inputType: 'select'
        },
        {
          props: ['serviceStatus'],
          placeholder: '接单状态',
          options: [
            {label: '接单', value: 1},
            {label: '休息', value: 2}
          ],
          inputType: 'select'
        }
      ],
      tableOptList: [],
      rowOptList: [],
      columns: [
        { title: '所在地区', dataIndex: 'address', align: '', width: '' },
        { title: '账号', dataIndex: 'mobilePhone', align: '', width: '' },
        { title: '商家名称', dataIndex: 'name', align: '', width: '' },
        { title: '服务类型', dataIndex: 'serviceTypeDesc', align: '', width: '' },
        { title: '服务范围', dataIndex: 'communityName', align: '', width: '' },
        { title: '开通时间', dataIndex: 'activeTime', align: '', width: '' },
        { title: '接单状态', dataIndex: 'serviceStatusDesc', align: '', width: '', scopedSlots: { customRender: 'status' } },
        { title: '服务状态', dataIndex: 'activeStatusDesc', align: '', width: '', scopedSlots: { customRender: 'serviceStatus' }}
      ],
      dataSource: [],
      searchParams: {
        mobilePhone: undefined,
        name: undefined,
        serviceStatus: undefined,
        activeStatus: undefined
      },
      listApi: {
        url: '/housekeep/serviceConfig/list',
        resHandle: '', // this.resHandle
        searchHandle: '' // searchHandle
      },
      addHandleParam: {
      },
      deleteParam: {
      }
    };
  },
  created () {
  },
  methods: {
    resHandle (res) {
      return res;
    },
    searchHandle (selectData) {
      return selectData;
    }
  }
};
</script>
<style scoped>

</style>
